import axios from 'axios';
import apiService from '../apiService';
import { getDic } from '../../assets/i18n/dictionary';

export default async function validateFace(
  base64 = "",
) {
  try {
    const _ret = await axios({
      url: `${apiService.getUrl().faceRecognition}faceDetection/validateFaceDetection`,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        base64: base64,
      },
    });

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return '';
  } catch (error) {
    console.error("Error validateFace", error);
    throw error;
  }
}
